/** English label for staff-facing blocks, and the resident fallback when the payload omits translationLabel. */
export const AI_GENERATED_TRANSLATION_LABEL = 'AI-generated translation';
